const pp = {
    toolsImg: require("@/assets/icon/PP.png"),
    toolsTitle: "飞桨PaddlePaddle",
    toolsTag: "开发框架",
    toolsDes: "飞桨 (PaddlePaddle)以百度多年的深度学习技术研究和业务应用为基础，集深度学习核心框架、基础模型库、端到端开发套件、工具组件和服务平台于一体，2016 年正式开源，是全面开源开放、技术领先、功能完备的产业级深度学习平台。飞桨源于产业实践，始终致力于与产业深入融合。目前飞桨已广泛应用于工业、农业、服务业等，服务 535万开发者，创造67万个模型，服务20万企事业单位，产学研用紧密协同培养超过200万AI人才，与合作伙伴一起帮助越来越多的行业完成 AI 赋能。",


    toolsChild: [
        {
            toolsChildId: 0,
            toolsTitle: "开发与训练",
            cardList: [
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Paddle核心框架",
                    cardDes: "开发便捷的深度学习框架",
                    cardLink: "https://github.com/paddlepaddle/paddle"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "FleetAPI",
                    cardDes: "分布式训练API",
                    cardLink: "https://github.com/PaddlePaddle/PaddleFleetX"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PALM",
                    cardDes: "多任务学习",
                    cardLink: "https://github.com/PaddlePaddle/PALM"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleCloud",
                    cardDes: "云上任务提交工具",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/paddlecloud"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Paddle Quantum",
                    cardDes: "量子机器学习框架",
                    cardLink: "https://qml.baidu.com/"
                },

            ]
        },
        {
            toolsChildId: 1,
            toolsTitle: "开发工具套件",
            cardList: [
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleHub",
                    cardDes: "预训练模型工具 便捷获取飞桨预训练模型，完成模型管理和一键预测。配合Fine-tune API，可基于大规模预训练模型快速完成迁移学习",
                    cardLink: "https://www.paddlepaddle.org.cn/hub"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleClas",
                    cardDes: "开发套件-图像分类",
                    cardLink: "https://github.com/PaddlePaddle/PaddleClas"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleDetection",
                    cardDes: "开发套件-目标检测",
                    cardLink: "https://github.com/PaddlePaddle/PaddleDetection"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleSeg",
                    cardDes: "开发套件-图像分割",
                    cardLink: "https://github.com/PaddlePaddle/PaddleSeg"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleOCR",
                    cardDes: "开发套件-文字识别",
                    cardLink: "https://github.com/PaddlePaddle/PaddleOCR"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleGAN",
                    cardDes: "开发套件-生成对抗网络",
                    cardLink: "https://www.paddlepaddle.org.cn/paddlegan"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "DeepSpeech",
                    cardDes: "开发套件-语音识别",
                    cardLink: "https://github.com/PaddlePaddle/PaddleSpeech"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Parakeet",
                    cardDes: "开发套件-语音合成",
                    cardLink: "https://github.com/PaddlePaddle/Parakeet"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "ERNIE",
                    cardDes: "开发套件-语义理解",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/ernie"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "ElasticCTR",
                    cardDes: "开发套件-点击率预估",
                    cardLink: "https://github.com/PaddlePaddle/ElasticCTR"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PLSC",
                    cardDes: "开发套件-海量类别分类",
                    cardLink: "https://github.com/PaddlePaddle/PLSC"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PGL",
                    cardDes: "开发套件-图神经网络",
                    cardLink: "https://github.com/PaddlePaddle/PGL"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PARL",
                    cardDes: "开发套件-强化学习",
                    cardLink: "https://github.com/PaddlePaddle/PARL"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleHelix",
                    cardDes: "开发套件-螺旋桨生物计算平台",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/paddlehelix"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleSpatial",
                    cardDes: "开发套件-时空大数据计算工具",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/PaddleSpatial"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleVideo",
                    cardDes: "开发套件-视频理解",
                    cardLink: "https://github.com/PaddlePaddle/PaddleVideo"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Paddle3D",
                    cardDes: "开发套件-3D感知",
                    cardLink: "https://github.com/PaddlePaddle/Paddle3D"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleSlim",
                    cardDes: "开发套件-模型压缩工具",
                    cardLink: "https://github.com/PaddlePaddle/PaddleSlim"
                },
            ]
        },
        {
            toolsChildId: 2,
            toolsTitle: "模型库",
            cardList: [
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleCV",
                    cardDes: "智能视觉",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/paddlecv"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleNLP",
                    cardDes: "智能文本处理",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/paddlenlp"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleRec",
                    cardDes: "智能推荐",
                    cardLink: "https://github.com/PaddlePaddle/PaddleRec"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleSpeech",
                    cardDes: "智能语音",
                    cardLink: "https://github.com/PaddlePaddle/models#PaddleSpeech"
                },
                {
                    cardImg: require("@/assets/icon/baidu-yiyan-icon.png"),
                    cardTitle: "文心大模型",
                    cardDes: "文心大模型",
                    cardLink: "https://wenxin.baidu.com/"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "PaddleTS",
                    cardDes: "深度时序算法库",
                    cardLink: "https://github.com/PaddlePaddle/PaddleTS"
                },
            ]
        },
        {
            toolsChildId: 3,
            toolsTitle: "部署工具及套件",
            cardList: [
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Paddle Inference",
                    cardDes: "原生推理库 飞桨面向服务器端的预测引擎，通过深度适配优化达到高吞吐、低时延，保证飞桨模型即训即用、快速部署",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/paddleinference"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Paddle Serving",
                    cardDes: "服务化部署框架",
                    cardLink: "https://github.com/PaddlePaddle/Serving"
                },

                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Paddle Lite",
                    cardDes: "轻量化推理引擎",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/paddlelite"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "Paddle.js",
                    cardDes: "前端推理引擎",
                    cardLink: "https://www.paddlepaddle.org.cn/paddle/paddlejs"
                },
                {
                    cardImg: require("@/assets/icon/PP.png"),
                    cardTitle: "FastDeploy",
                    cardDes: "推理部署",
                    cardLink: "https://github.com/PaddlePaddle/FastDeploy"
                },

            ]
        },
    ],
};
export default pp;